/**
 * Dopisek pod edytorem treści wychodzącej ze skrzynki zakupy@.
 *
 * Podpis osoby siedzi w TREŚCI edytora (wstawia go `withPersonalSignature`
 * przy otwarciu wątku w skrzynce albo przy zakładaniu nowej kampanii), więc ta
 * linijka mówi tylko, skąd się wziął i co zrobić, gdy czegoś w nim brakuje.
 * Do 07.09.2026 skrzynka zapowiadała podpis, który doklejała dopiero wysyłka —
 * ludzie zgłaszali, że „nic się nie pojawia", bo w edytorze go nie było.
 *
 * `whatGoesOut` to podmiot zdania o braku podpisu: „odpowiedź pójdzie" w
 * skrzynce, „maile kampanii pójdą" w kampanii.
 */
export function SignatureHint({ lines, whatGoesOut }: { lines: string[]; whatGoesOut: string }) {
  if (lines.length === 0) {
    return (
      <p className="mt-1 text-[11px] text-[var(--color-text-muted)]">
        W profilu nie ma imienia i nazwiska, więc {whatGoesOut} z samą stopką działu.
        Podpisz się w treści albo uzupełnij profil.
      </p>
    );
  }
  return (
    <p className="mt-1 text-[11px] text-[var(--color-text-muted)]">
      Podpis pod „Pozdrawiam" ({lines.join(", ")}) wstawiliśmy z Twojego profilu —
      możesz go poprawić w treści.
      {lines.length < 2 && " Telefonu nie ma w profilu, więc go tu nie ma."}
    </p>
  );
}
